import { SortOrder } from '@dealroadshow/uikit-table/DataTable/interfaces/SortOrder';

export const DEFAULT_PAGE = 1;
export const DEFAULT_PER_PAGE = 25;
export const DEFAULT_SORT_BY = 'name';
export const DEFAULT_SORT_ORDER: SortOrder = 'asc';
export const DEFAULT_SEARCH = '';
